/**
 * PrivacyENPrivacyTextView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacyENPrivacyText
 */

import { usePrivacyENPrivacyTextLogic } from '@/hooks/traits/usePrivacyENPrivacyTextLogic';
import type { PrivacyENPrivacyTextConfig } from '@/hooks/traits/usePrivacyENPrivacyTextLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacyENPrivacyView as PrivacyENPrivacyViewEntity } from '@app/shared';
import { Typography } from '@almadar/ui/components';
import { MarkdownContent } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Badge } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface PrivacyENPrivacyTextViewProps {
  config?: Partial<PrivacyENPrivacyTextConfig>;
}

export function PrivacyENPrivacyTextView({ config: propsConfig }: PrivacyENPrivacyTextViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacyENPrivacyTextLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacyENPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacyEN" trait="PrivacyENPrivacyText">
      {slotWriter['main'] === 'INIT' ? (<Box fullWidth={true} dir="ltr" paddingY="xl" bg={(false) ? "muted" : "transparent"}><Container padding="lg" size="md" maxWidth="md"><Stack gap="md" direction="vertical"><Badge label="" variant="primary" /><Typography variant="h1" content={renderPatternValue(__t("std-almadar-privacy:privacy.heading"))} weight="bold" size="3xl" className={((__t("std-almadar-privacy:privacy.heading") === "")) ? "hidden" : "tracking-tight text-balance"} /><Typography className={(true) ? "hidden" : ""} content="" color="muted" variant="caption" /><MarkdownContent content={String(__t("std-almadar-privacy:privacy.body"))} direction="ltr" /></Stack></Container></Box>) : null}
    </TraitScopeProvider>
  );
}

export default PrivacyENPrivacyTextView;
